export default {"src":"/_next/static/media/ic-back.4230bc48.svg","height":14,"width":9,"blurWidth":0,"blurHeight":0};